import { Pencil } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PageHeader } from '@/components/atoms'

interface ProfileHeaderProps {
    onEdit: () => void
}

export const ProfileHeader = ({ onEdit }: ProfileHeaderProps) => {
    return (
        <PageHeader
            size="large"
            title="Profile"
            description="Your account details and security."
            actions={
                <Button onClick={onEdit}>
                    <Pencil /> Edit profile
                </Button>
            }
        />
    )
}
